import {Loader, Text} from '@mantine/core';
import type {FC} from 'react';
import {ModalCancelButton} from '../ModalCancelButton';
import {SelectedInfoBox} from './SelectedInfoBox';

export const PROCESSING_STATE = {
  FETCHING_STEPS: 'fetchingSteps',
  CHECKING_ENTRY: 'checkingEntry',
  CREATING_ENTRY: 'creatingEntry',
  ADDING_STEPS: 'addingSteps',
  ERROR: 'error',
} as const;

export type ProcessingState =
  (typeof PROCESSING_STATE)[keyof typeof PROCESSING_STATE];

type Props = {
  onClose: () => void;
  processingState: ProcessingState;
  addedStepCount: number;
  totalStepCount: number;
  companyName: string;
  departmentLabel: string;
};

export const AiTodoProcessingContent: FC<Props> = ({
  onClose,
  processingState,
  addedStepCount,
  totalStepCount,
  companyName,
  departmentLabel,
}) => {
  const getProcessingMessage = (): string | JSX.Element => {
    switch (processingState) {
      case PROCESSING_STATE.FETCHING_STEPS:
        return '選考ステップを取得中...';
      case PROCESSING_STATE.CHECKING_ENTRY:
        return '選考管理を確認中...';
      case PROCESSING_STATE.CREATING_ENTRY:
        return '選考管理を作成中...';
      case PROCESSING_STATE.ADDING_STEPS:
        return totalStepCount > 0 ? (
          <>
            ステップを追加中...
            <br />({addedStepCount} / {totalStepCount})
          </>
        ) : (
          'ステップを追加中...'
        );
      default:
        return '';
    }
  };

  if (processingState === 'error') {
    return (
      <div className="flex flex-col items-center gap-16 p-16">
        <SelectedInfoBox
          companyName={companyName}
          departmentLabel={departmentLabel}
        />
        <Text className="text-black-2 text-center">
          選考ステップの取得に失敗しました
        </Text>
        <ModalCancelButton onClick={onClose}>閉じる</ModalCancelButton>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-16 p-16">
      <SelectedInfoBox
        companyName={companyName}
        departmentLabel={departmentLabel}
      />
      <Loader />
      <Text className="text-black-2 text-center">{getProcessingMessage()}</Text>
    </div>
  );
};
